import './index.css'

function Footer() {
    return (
        <div className="footer">
            <div className="container">
                {/* Investment Disclaimer */}
                <div className="footer-disclaimer">
                    <h4 className="disclaimer-title">Investment Disclaimer</h4>
                    <p className="disclaimer-text">
                        This analysis is generated by AI algorithms and provided for informational purposes only.
                        It should not be considered as financial, investment, or trading advice. Past performance
                        does not guarantee future results. Always conduct your own research and consult with qualified
                        financial advisors before making investment decisions.
                    </p>
                </div>

                {/* Copyright */}
                <div className="row text-center text-md-start gy-3">
                    <div className="col-md">
                        <div className="float-left pull-none">
                            <p className="copy-rights text-muted mb-3 mb-sm-0">
                                2026 © Abdullah Abbasi
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
  }
  export default Footer;
